import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { usePkce } from '@oliasoft/pkce';
import { Menu, Button, Icon } from '@oliasoft-open-source/react-ui-library';
import { routes } from 'views/navigation/routes/routes';
import translations from 'src/internationalisation/translation-map.json';
import { selectUserName } from 'src/store/entities/user/selectors';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

function UserMenu({ navigateToRoute, version, serverVersion, userName }) {
  const { t } = useTranslation();
  const { company } = useParams();
  const [activeCompany, setActiveCompany] = useState(null);
  const auth = usePkce();

  useEffect(() => {
    setActiveCompany(company);
    const eventHandler = () => {
      setActiveCompany(company);
    };
    window.addEventListener('storage', eventHandler);

    return () => window.removeEventListener('storage', eventHandler);
  }, []);

  const handleLogout = async () => {
    await auth.logout();
  };
  const initials = userName
    ?.split(' ')
    ?.filter((v) => v)
    ?.map((v) => v[0].toUpperCase())
    ?.join('');
  const isCompanySelected = company || activeCompany;
  return (
    <Menu
      offset={10}
      menu={{
        trigger: 'Component',
        placement: 'bottom-end',
        component: <Button testId="user-menu-button-user-initials" label={initials} round onClick={() => {}} colored />,
        sections: [
          { type: 'Heading', label: userName },

          ...(isCompanySelected
            ? [
                {
                  type: 'Option',
                  label: t(translations.settings_userSettings),
                  testId: 'user-menu-option-user-settings',
                  icon: <Icon icon="user" />,
                  onClick: () =>
                    navigateToRoute(routes.userSettings.nested.templates, {
                      company: company || activeCompany,
                    }),
                },
                {
                  type: 'Option',
                  label: t(translations.settings_companySettings),
                  testId: 'user-menu-option-company-settings',
                  icon: <Icon icon="company" />,
                  onClick: () =>
                    navigateToRoute(routes.companySettings.nested.currency, {
                      company: company || activeCompany,
                    }),
                },
              ]
            : [
                {
                  type: 'Option',
                  label: t(translations.selectCompany),
                  icon: 'refresh',
                  onClick: () => navigateToRoute('/'),
                },
              ]),
          { type: 'Divider' },
          {
            type: 'Option',
            label: t(translations.signOut),
            icon: <Icon icon="lock" />,
            onClick: handleLogout,
          },
          { type: 'Divider' },
          version && {
            type: 'Option',
            disabled: true,
            label: `${t(translations.clientVersion)}: ${version}`,
          },
          {
            type: 'Option',
            disabled: true,
            label: `${t(translations.serverVersion)}: ${serverVersion}`,
          },
        ],
      }}
    />
  );
}

const mapStateToProps = (state) => ({
  userName: selectUserName(state),
});

const Container = withErrorBoundary(connect(mapStateToProps)(UserMenu));

export default Container;
